module.exports = __webpack_public_path__ + "img/equipos-moviles-gal-1-zoom.5ce17dfa.jpg";